// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"18e65584","721":"f33a6846","951":"6348bd2c"}[chunkId] + ".chunk.js";
};